<div *ngIf="!(tableDataSource.loading$ | async) && totalRecords === 0" class="no-results">
    <div class="no-result-icon">
        <div>
            No payments found to display.
        </div>
    </div>
</div>

<div [class.hidden]="(tableDataSource && (tableDataSource.loading$ | async)) || totalRecords === 0" class="table-responsive ledger-table">
    <mat-table #table [dataSource]="tableDataSource" class="table"
               matSort
               matSortActive="createdAt" matSortDirection="desc" matSortDisableClear="true">

        <!-- check box -->
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef class="checkbox-cell">
                <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection && selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection && selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="checkbox-cell">
                <mat-checkbox (change)="$event ? rowSelected(row, $event) : null"
                              (click)="$event.stopPropagation()"
                              *ngIf="row.deletable"
                              [checked]="selection && selectedPaymentIds.indexOf(row.id) !== -1">
                </mat-checkbox>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="checkbox-cell">
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="organizationId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Org ID
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.organizationId }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="organization">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Organization
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.organization.name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="payorId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Payor ID
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.payorId }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="payorName">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Payor
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <ng-container *ngIf="!isOnMaster else onMaster">
                    <div *ngIf="row.payor.unit">{{ row.payor.unit.title }}</div>
                    <div *ngIf="!row.payor.unit">No unit for this payor</div>
                    <div class="lower-text">{{ row.payor.name }}</div>
                </ng-container>
                <ng-template #onMaster>
                    <div>{{ row.payor.name }}</div>
                </ng-template>

            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Payment Date
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div class="d-flex justify-content-between align-items-center">
                    {{ row.createdAt | legfiDate:'MM/DD/YYYY' }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="depositDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Deposit Date
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div class="d-flex justify-content-between align-items-center" *ngIf="row.isLinked">
                    <button class="btn btn-link p-0" (click)="openDepositDetail(row.paymentAttempts[0].lastTransaction.transaction)">
                        {{ row.depositDate | legfiDate:'MM/DD/YYYY' }}
                    </button>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="applied">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Amount
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span [innerHTML]="row.applied | legfiCurrency:row.currency:'symbol':'.2'"></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                <ng-container *ngIf="!isOnMapModal">
                    {{ footerData.totalAmount | legfiCurrency:'usd':'symbol':'.2' }}
                </ng-container>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="absorbedFees">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Fees
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span [innerHTML]="row.absorbedFees | legfiCurrency:row.currency:'symbol':'.2'"></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                {{ footerData.totalFees | legfiCurrency:'usd':'symbol':'.2' }}
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="net">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Net Amount
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span [innerHTML]="row.net | legfiCurrency:row.currency:'symbol':'.2'"></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                {{ footerData.totalNet | legfiCurrency:'usd':'symbol':'.2' }}
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="categoryAmount">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Category Amount
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span [innerHTML]="row.paymentItemSum | legfiCurrency:row.currency:'symbol':'.2'"></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
                {{ footerData.categoryTotal | legfiCurrency:'usd':'symbol':'.2' }}
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="paymentMethodType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Payment Method
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div class="d-flex flex-row align-items-center">
                    <span class="mr-1">{{ row.friendlyPaymentMethod }}</span>
                    <span *ngIf="row.autopaid" style="color: #49B99F;">• Autopaid</span>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="notes">
            <mat-header-cell *matHeaderCellDef>
                Note
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <span *ngIf="row.notes && row.notes.length > 0" [innerHTML]="row.notes[0].note"></span>
                <div class="text-muted" matTooltip="recorded by {{row.createdBy.name}} on {{row.importedAt | legfiDate:'MM/DD/YYYY h:mm a'}}" *ngIf="row.createdBy">
                    Recorded by {{ row.createdBy.name }}
                </div>
                <div class="text-muted" matTooltip="deleted by {{row.deletedBy.name}} on {{row.updatedAt | legfiDate:'MM/DD/YYYY h:mm a'}}" *ngIf="row.deletedBy">
                    Deleted by {{ row.deletedBy.name }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>
                Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <app-single-payment-actions (reload)="loadPayments.emit()" [paymentGroup]="row"></app-single-payment-actions>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" [class.deleted]="!row.hasValidPayments"></mat-row>
        <ng-container *ngIf="!isOnDashboard">
            <mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></mat-footer-row>
        </ng-container>
    </mat-table>
</div>
<mat-paginator #matPaginator
               [class.hidden]="(tableDataSource.loading$ | async) || !totalRecords"
               [length]="totalRecords"
               [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize">
</mat-paginator>
